import { Button, Modal } from "react-bootstrap";
import { useLocation, useNavigate } from "@reach/router";

import { ThemedButton } from "components/BuildingBlocks";
import { LOGIN_MODAL_MESSAGE } from "constants/login-modal";

export default function LoginModal(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const handleClose = () => props.setShowLoginModal(false);
  const redirectToLogin = () =>
    navigate("/login?redirect=" + location.pathname);
  return (
    <Modal show={props.showLoginModal} onHide={handleClose}>
      <Modal.Body>{LOGIN_MODAL_MESSAGE}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <ThemedButton onClick={redirectToLogin}>Login</ThemedButton>
      </Modal.Footer>
    </Modal>
  );
}
